import DomFactory from '../../common/factory/factory';

export default class ImageViewFactory extends DomFactory {
  public createWrapper() {
    const quizContainer = document.createElement('div');
    quizContainer.classList.add('image-view-container');
    return quizContainer;
  }

  public createImage({ src }: Partial<HTMLImageElement>) {
    const imageElement = document.createElement('img');
    imageElement.src = src || '';
    imageElement.classList.add('image-generated');
    return imageElement;
  }

  private createSvgLoading() {
    return `
        <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" classname="animate-spin">
          <circle
            cx="6"
            cy="6"
            r="5"
            class="opacity-25"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M1 6C1.00003 3.5 2.6667 1 6 1"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
        `;
  }

  public createLoading() {
    const divElement = document.createElement('div');
    divElement.classList.add('image-loading');
    divElement.innerHTML = this.createSvgLoading();
    return divElement;
  }

  private createSvgFallback() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
        `;
  }

  public createFallback() {
    const divElement = document.createElement('div');
    divElement.classList.add('image-fallback');
    divElement.innerHTML = this.createSvgFallback();
    divElement.appendChild(
      this.createText(
        this.i18n.t('Enter your prompt and generate the image'),
        'image-fallback-message',
      ),
    );
    return divElement;
  }

  private createSvgError() {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        `;
  }

  private createText(error: string, className: string) {
    const divElement = document.createElement('p');
    divElement.classList.add(className);
    divElement.innerHTML = error;
    return divElement;
  }

  public createError(error: string) {
    const divElement = document.createElement('div');
    divElement.classList.add('image-error');
    divElement.innerHTML = this.createSvgError();
    divElement.appendChild(this.createText(error, 'image-error-message'));
    return divElement;
  }
}
